import useProperties from "hooks/useProperties";
import React, { useState } from "react";

const text = `Situata nella zona di Broadmoor, questa proprietà dispone di 2
            camere da letto indipendenti, 2 bagni completi, un ponte posteriore
            coperto e un nuovo scaldabagno. Il venditore non effettuerà alcuna
            riparazione alla proprietà, richiesta dal creditore o
            dall'acquirente. L'acquirente deve accettare Situata nella zona di Broadmoor, questa proprietà dispone di 2
            camere da letto indipendenti, 2 bagni completi, un ponte posteriore
            coperto e un nuovo scaldabagno. Il venditore non effettuerà alcuna
            riparazione alla proprietà, richiesta dal creditore o
            dall'acquirente. L'acquirente deve accettare`;

const PropertyDescriptionComponent = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const previewLength = 344;
  const { propertyDetails: property } = useProperties();

  const toggleText = () => setIsExpanded(!isExpanded);
  return (
    <div className="pb-4 border-b border-[#F0F0F0] mt-4 sm:mt-5 md:mt-[23px] ">
      <h1 className="text-[16px] md:text-[22px] leading-[150%] text-black font-semibold ">
        Descrizione
      </h1>
      <p className="mt-2 md:mt-3 text-[14px] sm:text-[16px] leading-[150%] text-black font-light">
        {isExpanded
          ? property?.description
          : `${property.description.slice(0, previewLength)}...`}{" "}
        {property.description.length > previewLength && (
          <button
            onClick={toggleText}
            className="text-[#000CF9] focus:outline-none"
          >
            {isExpanded ? "Leggi meno" : "Leggi"}
          </button>
        )}
      </p>
    </div>
  );
};

export default PropertyDescriptionComponent;
